// Bus de toasts sin dependencias ni contexto React: se puede disparar desde
// cualquier callback (mutations, handlers) y el <Toaster /> los pinta.

export type ToastVariant = "success" | "error" | "info";

export interface ToastItem {
  id: string;
  variant: ToastVariant;
  title: string;
  description?: string;
}

type Listener = (item: ToastItem) => void;

const listeners = new Set<Listener>();
let sequence = 0;

export function toast(input: {
  variant?: ToastVariant;
  title: string;
  description?: string;
}): void {
  const item: ToastItem = {
    id: `t${Date.now().toString(36)}-${(sequence += 1).toString(36)}`,
    variant: input.variant ?? "info",
    title: input.title,
    ...(input.description ? { description: input.description } : {}),
  };
  for (const listener of listeners) listener(item);
}

export function subscribeToast(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
